import AmexTerms from './AmexTerms';

export default AmexTerms;
